import { IconButton as BaseIconButton, IconButtonProps, forwardRef } from '@chakra-ui/react';
import React from 'react';

// eslint-disable-next-line react/display-name
const IconButton = forwardRef<IconButtonProps, 'button'>((props, ref) => (
  <BaseIconButton ref={ref} borderRadius="round" variant="icon" size="icon" {...props} />
));

export default IconButton;
